import { render } from "./Onlineexamination.vue?vue&type=template&id=775ecd52"
import script from "./Onlineexamination.vue?vue&type=script&lang=js"
export * from "./Onlineexamination.vue?vue&type=script&lang=js"

import "./Onlineexamination.vue?vue&type=style&index=0&id=775ecd52&lang=css"
script.render = render

export default script